import { Reducer } from "redux";
import { User, Invite } from "../components/users/types";

export const SET_USERS = "SET_USERS";

export interface UsersState {
  users: User[];
  currentUser: User | undefined;
  invitedUsers: Invite[];
  loading: boolean;
}

export const initialUsersState: UsersState = {
  users: [],
  currentUser: undefined,
  invitedUsers: [],
  loading: true,
};

type SetUsersAction = {
  type: typeof SET_USERS;
  users: User[];
  currentUser: User | undefined;
  invitedUsers: Invite[];
};

type UsersActions = SetUsersAction;

const usersReducer: Reducer<UsersState, UsersActions> = (
  state = initialUsersState,
  action
): UsersState => {
  if (action === undefined) {
    return initialUsersState;
  }

  switch (action.type) {
    case SET_USERS:
      return {
        users: action.users,
        currentUser: action.currentUser,
        invitedUsers: action.invitedUsers,
        loading: false,
      };
    // This clause looks redundant, but it's needed for when redux calls this
    // reducer with an initialization action to get the initial state.
    default:
      return state;
  }
};

export default usersReducer;
